<template>
  <div class="branded_logos">
    <span class="branded__images" v-if="clioLogo">
      <img class="branded__image" :src="partnerLogo" :alt="`${partnerTitle} logo`">
      <img class="branded__image" :src="clioBrandedImage" alt="Clio Muse Tours logo">
    </span>
    <img v-else class="branded__image branded__image--single" :src="partnerLogo" :alt="`${partnerTitle} logo`">
  </div>
</template>

<script type="text/javascript">
  
  export default {
    props: {
      clioLogo: {
        default: true,
        type: Boolean
      },
      partnerLogo: String,
      partnerTitle: String
    },
    data() {
      return {
        clioBrandedImage: '/icons/clio-muse-tours-logo-red.svg'
      }
    }
  };

</script>